import { useState } from "react"

export const useFieldExpansion = () => {
  const [expandedFields, setExpandedFields] = useState<Set<string>>(new Set())

  const toggleExpanded = (key: string) => {
    const newExpanded = new Set(expandedFields)
    if (newExpanded.has(key)) {
      newExpanded.delete(key)
    } else {
      newExpanded.add(key)
    }
    setExpandedFields(newExpanded)
  }

  const collapseField = (key: string) => {
    const newExpanded = new Set(expandedFields)
    newExpanded.delete(key)
    setExpandedFields(newExpanded)
  }

  const isExpanded = (key: string) => expandedFields.has(key)

  return {
    expandedFields,
    toggleExpanded,
    collapseField,
    isExpanded
  }
}
